// @flow
import React, {   
  Fragment,
  useCallback,
  useEffect,
  useState 
} from 'react'

import { Loader } from '@driftt/tide-core'
import { tracking } from '@driftt/traffic-control'
import { getImports } from 'api/contacts'
import ImportsTable from 'components/Imports/ImportsTable'
import ImportTableEmptyState from 'components/Imports/ImportTableEmptyState'
import Paginator from 'components/Paginator'

import './CSVstyle.css'

const CSVImports = ({
  onReceiveImports,
  imports 
}) => {
  const [importsLoading, setImportsLoading] = useState(true)
  const [index, setIndex] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)
  const [size, setSize] = useState(25)
  const [totalPages, setTotalPages] = useState(null)

  useEffect(() => tracking.trackEvent('Contact Import Logs - Page Viewed'), [])

  const changeSize = ({ value }) => {
    setSize(value)
  }

  const nextPage = () => {
    const newIndex = index + size
    const nextPage = currentPage + 1
    setCurrentPage(nextPage)
    setIndex(newIndex)
  } 

  const previousPage = () => {
    const newIndex = index - size
    setCurrentPage(currentPage - 1)
    setIndex(newIndex)
  }

  const fetchImports = useCallback(() => {
    async function fetch() {
      try {
        const { data } = await getImports(size, index)
      
        onReceiveImports(data.summaries)

        setImportsLoading(false)
        setIndex(data.offset)
        setTotalPages(Math.ceil(data.totalCount / size))
      } catch (err) {
        console.log(err)
      }
    }
    fetch()
  },[size, index, onReceiveImports])

  useEffect(() => fetchImports(), [size, index, fetchImports])

  return (
    <div className="imports-home">
      {importsLoading &&
          <span className="imports-home-table-fetcher">
            <Loader type="table" width={window.innerWidth - 60} />
          </span>
      }

      {!!imports &&
          <div className="imports-table-container">
            <ImportsTable
              hasFinished={!importsLoading}
              imports={imports}
            />
          </div>
      }

      {!!imports &&
          <Paginator
            totalPages={totalPages}
            size={size}
            goBackward={previousPage}
            goForward={nextPage}
            changeSize={changeSize}
            index={currentPage}
          />
      }

      {(!imports && !importsLoading) && 
          <Fragment>
            <ImportTableEmptyState/>
          </Fragment>
      }
    </div>
  )
}

export default CSVImports
